import { useEffect } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import Lenis from "lenis";
import { FileText } from "lucide-react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { trackVisit } from "@/lib/track";

export const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    trackVisit(pathname);
  }, [pathname]);

  return (
    <div className="App min-h-screen bg-sand">
      <Navbar />
      <main className="pt-24 md:pt-28">
        <Outlet />
      </main>
      <Footer />

      <Link
        to="/contact"
        data-testid="sticky-devis-cta"
        className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 bg-olive text-white pl-5 pr-6 py-4 rounded-full shadow-lift hover:scale-105 hover:bg-olive-hover transition-all duration-300"
      >
        <FileText size={18} />
        <span className="font-semibold text-sm">Demander un devis</span>
      </Link>
    </div>
  );
};
